import React, { useState } from 'react';
import { AppProvider } from '@toolpad/core/AppProvider';
import { SignInPage } from '@toolpad/core/SignInPage';
import { useTheme } from '@mui/material/styles';
import { apiMain } from "../../App";
import { useNavigate, Link } from "react-router-dom";
import { GetDataPromise } from "../Functions/SendingData";
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const providers = [{ id: 'credentials', name: 'Email and password' }];

export default function CredentialsSignInPage() {
  let navigate = useNavigate(); 
  const [Open, setOpen] = useState(true);
  const theme = useTheme();

  function handelClose(e) {
    setOpen(e)
  };

  const signIn = async (provider, formData) => {
    const email = formData?.get('email');
    const password = formData?.get('password');
    let uparams = new URLSearchParams();

    uparams.append("U_Name", email);
    uparams.append("U_Password", password);

    let res = await GetDataPromise(`${apiMain}/api/v1/users/select?${uparams}`, true);
    let parsed = JSON.parse(res);

    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      // console.log(newData);
      localStorage.setItem("U_id", newData[0].U_id);
      navigate('/Home', { state: { id: 1, name: newData[0].U_id } });
         } else {
      alert(
        `Signing in with "${provider.name}" and credentials: ${email}, ${password}`,
      );
    }
  };

  return (
    <Dialog open={Open}>
      <IconButton
        aria-label="close"
        onClick={() => handelClose(false)}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>

      <AppProvider theme={theme}>
        <SignInPage
          signIn={signIn}
          providers={providers}
          slotProps={{ emailField: { autoFocus: false } }}
        />

        {/* قسمت لینک‌ها */}
        <Box sx={{ textAlign: "center", p: 2 }}>
          <Typography variant="body2">
          Don't have an account?{" "}
            <Link to="/register">Register</Link>
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            <Link to="/forget-password"> Did you forget your passwird? </Link>
          </Typography>
        </Box>
      </AppProvider>
    </Dialog>
  );
}
